import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import { getToken } from '@/api/request'

// 路由元信息扩展：标题、菜单图标、是否公开。
declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    /** Element Plus 图标组件名（已全局注册）。 */
    icon?: string
    /** 公开页（无需登录）。 */
    public?: boolean
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { title: '登录', public: true },
  },
  {
    path: '/',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: { title: '概览', icon: 'Odometer' },
      },
      {
        path: 'accounts',
        name: 'accounts',
        component: () => import('@/views/accounts/AccountListView.vue'),
        meta: { title: '玩家账号', icon: 'User' },
      },
      {
        path: 'achievements',
        name: 'achievements',
        component: () => import('@/views/achievements/AchievementListView.vue'),
        meta: { title: '成就', icon: 'Trophy' },
      },
      {
        path: 'orders',
        name: 'orders',
        component: () => import('@/views/orders/OrderListView.vue'),
        meta: { title: '订单 / 支付', icon: 'CreditCard' },
      },
      {
        path: 'ads',
        name: 'ads',
        component: () => import('@/views/ads/AdListView.vue'),
        meta: { title: '广告', icon: 'VideoPlay' },
      },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/config/GameConfigView.vue'),
        meta: { title: '游戏配置', icon: 'Setting' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { title: '页面不存在', public: true },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to) => {
  const authed = !!getToken()
  if (!to.meta.public && !authed) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  if (to.path === '/login' && authed) {
    return { path: '/' }
  }
  return true
})

router.afterEach((to) => {
  const base = import.meta.env.VITE_APP_TITLE || '幸运房东 · 后台'
  document.title = to.meta.title ? `${to.meta.title} · ${base}` : base
})

export default router
